module.exports = __webpack_public_path__ + "media/images/homes/arrow-2-a194a68f701a61c90aafcc255b984390.svg";